import CryptoJS from 'crypto-js';
import md5 from 'js-md5';
const privateKey = 'JHXKJHZN';

export function encryptByDES(message) {
  const keyHex = CryptoJS.enc.Utf8.parse(privateKey);
  var base64String = 'EjRWeJCrze8=';
  var iv = CryptoJS.enc.Base64.parse(base64String);
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString();
}

export function sign(params, time) {
  var md5Str = '';
  md5Str += time;
  if (params && params !== null && params !== undefined) {
    Object.keys(params).forEach(function (key) {
      if (params[key] instanceof Array) {
        if(params[key].length>0){
          for (var i = 0; i < params[key].length; i++) {
            if(params[key][i].toString()==='[object Object]'){
              if (i === 0) {
                md5Str += "[";
                md5Str+=objsign(params[key][i]);
              }
              else{
                md5Str+=','+objsign(params[key][i]);
              }
              if (i === params[key].length - 1) {
                md5Str += "]";
              }
            }
            else{
              if (i === 0) {
                md5Str += "[";
                md5Str += '"' + params[key][i] + '"';
              }
              else {
                md5Str += ',"' + params[key][i] + '"';
              }
              if (i === params[key].length - 1) {
                md5Str += "]";
              }
            }
          }
        }
        else{
          md5Str += "[]";
        }
      }
      else {
        if (params[key] !== null && params[key] !== undefined && params[key] !== "undefined" && params[key] !== "null") {
          md5Str += params[key];
        }
      }
    });
  }
  md5Str += privateKey;
  return md5(md5Str).toUpperCase();
}

function objsign(params) {
  let md5Str='';
  md5Str+="{";
  if (params && params !== null && params !== undefined) {
    Object.keys(params).forEach(function (key,index) {
      if (params[key] !== null && params[key] !== undefined && params[key] !== "undefined" && params[key] !== "null") {
        if(index===0){
          md5Str += '"'+key+'":"'+params[key]+'"';
        }
        else{
          md5Str += ',"'+key+'":"'+params[key]+'"';
        }
      }
    });
    md5Str+="}";
  }
  return md5Str;
}